module.exports = __webpack_public_path__ + "assets/Space-suitWa.4d3e424c.svg";